module.exports = __webpack_public_path__ + "static/media/geckoterminal.2160d77c.svg";